import React from 'react';
import { Grid, Box } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { BodyContainer, AbsoluteGrid } from 'containers/LegalNoticePage/styles';
import {
  StyledCard,
  StyledSmallSectionHeader,
} from 'containers/ContactUsPage/styles';
import { ShortBody } from 'components/Typography';
import messages from 'containers/ContactUsPage/messages';
import { translate } from 'helpers/intl';
import { get } from 'lodash';
import ContactUsForm from 'containers/ContactUsPage/Body/Form';

const Body = (props: { intl: IntlShape }) => {
  return (
    <Grid container alignItems="center" justify="center">
      <BodyContainer>
        <AbsoluteGrid>
          <Box paddingTop={5} p={5}>
            <StyledCard>
              <Grid container direction="column" spacing={1}>
                <Grid item xs={12}>
                  <StyledSmallSectionHeader>
                    {translate(get(messages, 'title_Content'), props)}
                  </StyledSmallSectionHeader>
                </Grid>
                <Grid item xs={12}>
                  <ShortBody>
                    {translate(get(messages, 'contact_description'), props)}
                  </ShortBody>
                </Grid>
                <Grid item xs={12}>
                  <ContactUsForm />
                </Grid>
              </Grid>
            </StyledCard>
          </Box>
        </AbsoluteGrid>
      </BodyContainer>
    </Grid>
  );
};
export default injectIntl(Body);
